// removed by extract-text-webpack-plugin
module.exports = {"oddsButton":"_2f0EDGPSiVt-3x6yUI9hla","checked":"m5vKP10M_Z_5JqiAvSOLF","disabled":"Rw8bmdQMegekmr1oLdff0","selected":"V-x-LbnfbnPuMPoXN1kem","oddsButtonCustom":"CL-AGGDRJFn6kK4DCDm0r"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/tennis/css/oddsButtonTennis.css
// module id = 976
// module chunks = 0